iScreenWizard.controller('EtrainingmoduleController', function ($scope, $state, $mdDialog, Ajax, ErrorHandler, Dictionary, Etrainingmodule, userService) {

    $scope.etrainingmodules = [];
    $scope.userService = userService;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    var refresh = function() {
        Etrainingmodule.all().then(function (etrainingmodules) {
            $scope.etrainingmodules = etrainingmodules;
        });
    };
    $scope.refresh = refresh;

    $scope.viewEtrainingmodule = function(etrainingmodule, ev) {

        $mdDialog.show({
            controller: EtrainingmoduleDialogController,
            locals: {
                etrainingmodule: etrainingmodule
            },
            templateUrl: '/mijn-iscreen/etrainingmodules/show',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true
        });

    };

    function EtrainingmoduleDialogController($scope, etrainingmodule) {
        $scope.etrainingmodule = etrainingmodule;
    };

});